import _ from 'lodash';

const moduleName = 'ProspectingProjectTaskNode';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
